module.exports = __webpack_public_path__ + "img/PP_Sword_0080.4f3a228d.png";